module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_primaerlogo_moere_og_romsdal_neg.0049c538.png";